'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _class6, _temp3, _dec4, _class7, _class8, _temp4, _dec5, _class9, _class10, _temp5, _dec6, _dec7, _dec8, _class11, _class12, _temp6;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

var _reactSlidedown = require('react-slidedown');

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _FundFossilFuelInvestments = require('./FundFossilFuelInvestments.css');

var _FundFossilFuelInvestments2 = _interopRequireDefault(_FundFossilFuelInvestments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// we could do pagination a few at a time, but we'll do click to show all
var FirstPage = 5;
var AllPage = 1000000;

function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}

function filterHoldings(fHoldingsMap, holdings, filterFn) {
  // console.log('filtering holdings!!')
  // console.log(filterFn)
  return (0, _lodash.chain)(holdings).filter(filterFn).sortBy(function (o) {
    return fHoldingsMap[o.id].market_value * -1;
  })
  // .take(10)
  .value();
}

var SectorDetailsSwitches = (_dec = (0, _reactCssModules2.default)(_FundFossilFuelInvestments2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SectorDetailsSwitches, _Component);

  function SectorDetailsSwitches(props) {
    (0, _classCallCheck3.default)(this, SectorDetailsSwitches);
    return (0, _possibleConstructorReturn3.default)(this, (SectorDetailsSwitches.__proto__ || (0, _getPrototypeOf2.default)(SectorDetailsSwitches)).call(this, props));
  }

  (0, _createClass3.default)(SectorDetailsSwitches, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          clickSector = _props.clickSector,
          increment = _props.increment,
          sector = _props.sector,
          fund = _props.fund,
          shareClass = _props.shareClass,
          fHoldingsMap = _props.fHoldingsMap,
          activeSector = _props.activeSector,
          fossilsPage = _props.fossilsPage;

      //

      return _react2.default.createElement(
        'div',
        { id: 'sector-id-' + sector[0] },
        _react2.default.createElement(
          SectorDetailsSwitch,
          {
            clickSector: clickSector,
            type: sector[0],
            label: sector[1],
            sublabel: sector[2],
            count: fund[sector[3]],
            weight: fund[sector[4]],
            asset: fund[sector[5]],
            currency: shareClass.currency,
            activeSector: activeSector
          },
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            /* render the holding list if the sector is active */
            activeSector === sector[0] ? _react2.default.createElement(HoldingsListDisplay, {
              increment: increment,
              shareClass: shareClass,
              fHoldingsMap: fHoldingsMap,
              type: sector[0],
              label: sector[1],
              count: shareClass[sector[3]],
              holdings: sector[6],
              page: fossilsPage
            }) : null
          )
        )
      );
    }
  }]);
  return SectorDetailsSwitches;
}(_react.Component), _class2.propTypes = {
  clickSector: _react.PropTypes.func,
  increment: _react.PropTypes.func,
  sector: _react.PropTypes.array,
  fund: _react.PropTypes.object,
  shareClass: _react.PropTypes.object,
  fHoldingsMap: _react.PropTypes.object,
  activeSector: _react.PropTypes.string,
  fossilsPage: _react.PropTypes.number
}, _temp)) || _class);
var SectorDetailsSwitch = (_dec2 = (0, _reactCssModules2.default)(_FundFossilFuelInvestments2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(SectorDetailsSwitch, _Component2);

  function SectorDetailsSwitch(props) {
    (0, _classCallCheck3.default)(this, SectorDetailsSwitch);
    return (0, _possibleConstructorReturn3.default)(this, (SectorDetailsSwitch.__proto__ || (0, _getPrototypeOf2.default)(SectorDetailsSwitch)).call(this, props));
  }

  (0, _createClass3.default)(SectorDetailsSwitch, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          clickSector = _props2.clickSector,
          type = _props2.type,
          label = _props2.label,
          sublabel = _props2.sublabel,
          count = _props2.count,
          weight = _props2.weight,
          asset = _props2.asset,
          currency = _props2.currency,
          activeSector = _props2.activeSector;

      // images
      // circle icon

      var iconUnfilled = require('../../../static/images/icn-' + type + '.svg');
      // circle icon filled in
      var iconFilled = require('../../../static/images/icn-' + type + '-active.svg');
      // circle icon inactive
      var iconGrey = require('../../../static/images/icn-' + type + '-inactive.svg');

      // clean or dirty?
      var isDirty = _convert2.default.int(count);
      // currently active?
      var isActive = type === activeSector;
      // what style?
      var currIcon = null;
      var cleanDirtyStyle = '';

      if (isDirty) {
        if (isActive) {
          cleanDirtyStyle = 'detail-sector-' + type + '-active';
          currIcon = iconFilled;
        } else {
          cleanDirtyStyle = 'detail-sector-' + type + '-normal';
          currIcon = iconUnfilled;
        }
      } else {
        cleanDirtyStyle = 'detail-sector-clean';
        currIcon = iconGrey;
      }

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'detail-sector-wrapper ' + cleanDirtyStyle },
        _react2.default.createElement(
          'div',
          {
            onClick: function onClick() {
              clickSector(type, isDirty);
            }
          },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-sector-detail-flex' },
            ' ',
            _react2.default.createElement(
              'div',
              { styleName: 'detail-sector-detail-icon-wrap' },
              _react2.default.createElement('img', {
                styleName: 'detail-icon',
                src: currIcon,
                alt: label
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-active' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  label
                )
              ),
              sublabel ? _react2.default.createElement(
                'div',
                { styleName: 'detail-sublabel' },
                sublabel
              ) : null
            ),
            /* if dirty, render sector stats. else, render a badge */
            isDirty ? _react2.default.createElement(
              'div',
              { styleName: 'detail-sector-stat-wrapper' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-active' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-stat-figure' },
                  _format2.default.number(count)
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-stat-label' },
                  'holdings'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-active' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-stat-figure' },
                  _format2.default.money(asset, true, currency, true)
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-stat-label' },
                  'invested'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-active' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-stat-figure' },
                  _format2.default.perc(weight)
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-stat-label' },
                  'of portfolio'
                )
              )
            ) : _react2.default.createElement(
              'div',
              { styleName: 'single-badge-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'single-badge-text' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'single-badge-subtitle' },
                  'No direct stock holdings'
                )
              )
            )
          )
        ),
        this.props.children
      );
    }
  }]);
  return SectorDetailsSwitch;
}(_react.Component), _class4.propTypes = {
  clickSector: _react.PropTypes.func,
  type: _react.PropTypes.string,
  label: _react.PropTypes.string,
  sublabel: _react.PropTypes.string,
  count: _react.PropTypes.string,
  weight: _react.PropTypes.string,
  asset: _react.PropTypes.string,
  currency: _react.PropTypes.string,
  activeSector: _react.PropTypes.string
}, _temp2)) || _class3);
var HoldingsListDisplay = (_dec3 = (0, _reactCssModules2.default)(_FundFossilFuelInvestments2.default, { allowMultiple: true }), _dec3(_class5 = (_temp3 = _class6 = function (_Component3) {
  (0, _inherits3.default)(HoldingsListDisplay, _Component3);

  function HoldingsListDisplay(props) {
    (0, _classCallCheck3.default)(this, HoldingsListDisplay);
    return (0, _possibleConstructorReturn3.default)(this, (HoldingsListDisplay.__proto__ || (0, _getPrototypeOf2.default)(HoldingsListDisplay)).call(this, props));
  }

  (0, _createClass3.default)(HoldingsListDisplay, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          increment = _props3.increment,
          shareClass = _props3.shareClass,
          fHoldingsMap = _props3.fHoldingsMap,
          type = _props3.type,
          label = _props3.label,
          count = _props3.count,
          holdings = _props3.holdings,
          page = _props3.page;


      var _count = _convert2.default.int(count);
      var hasMoreButton = page === 1 && _count > FirstPage ? _react2.default.createElement(
        'div',
        {
          styleName: 'detail-more-' + type,
          onClick: increment(type === 'fossils' ? 'fossilsPage' : 'sectorPage')
        },
        'See all'
      ) : null;

      if (_count === 0) {
        return null;
      }

      var holdingsCountString = _format2.default.number(_count) + ' holdings';

      //
      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { xs: 12, styleName: 'detail-holdings-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-fossils' },
          type === 'fossils' ? _react2.default.createElement(
            'div',
            { styleName: 'detail-title-holdings' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-' + type },
              label
            ),
            _react2.default.createElement(
              'div',
              {
                styleName: 'visible-sm visible-md visible-lg ' + 'detail-holdings-count-' + type
              },
              holdingsCountString
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'visible-xs mobile-holdings-label' },
              holdingsCountString
            )
          ) : null,
          _react2.default.createElement(HoldingsList, {
            shareClass: shareClass,
            fHoldingsMap: fHoldingsMap,
            holdings: holdings,
            page: page
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'right' } },
          hasMoreButton
        )
      );
    }
  }]);
  return HoldingsListDisplay;
}(_react.Component), _class6.propTypes = {
  increment: _react.PropTypes.func,
  shareClass: _react.PropTypes.object,
  fHoldingsMap: _react.PropTypes.object,
  type: _react.PropTypes.string,
  label: _react.PropTypes.string,
  count: _react.PropTypes.string,
  holdings: _react.PropTypes.array,
  page: _react.PropTypes.number
}, _temp3)) || _class5);
var HoldingsList = (_dec4 = (0, _reactCssModules2.default)(_FundFossilFuelInvestments2.default, { allowMultiple: true }), _dec4(_class7 = (_temp4 = _class8 = function (_Component4) {
  (0, _inherits3.default)(HoldingsList, _Component4);

  function HoldingsList(props) {
    (0, _classCallCheck3.default)(this, HoldingsList);
    return (0, _possibleConstructorReturn3.default)(this, (HoldingsList.__proto__ || (0, _getPrototypeOf2.default)(HoldingsList)).call(this, props));
  }

  (0, _createClass3.default)(HoldingsList, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          shareClass = _props4.shareClass,
          fHoldingsMap = _props4.fHoldingsMap,
          holdings = _props4.holdings,
          page = _props4.page;


      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'holdings-none' },
          'NONE'
        );
      }

      var takeCount = page > 1 ? AllPage : FirstPage;

      // images
      var iconC2 = require('../../../static/images/icn-c2-active.svg');
      var iconCo = require('../../../static/images/icn-co-active.svg');
      var iconOg = require('../../../static/images/icn-og-active.svg');
      var iconF5 = require('../../../static/images/icn-f5-active.svg');
      var iconUt = require('../../../static/images/icn-ut-active.svg');

      var iconConfigs = [['is_c2', iconC2, 'Carbon Underground 200'], ['is_co', iconCo, 'Coal industry'], ['is_og', iconOg, 'Oil/gas industry'], ['is_f15', iconF5, 'Macroclimate 50'], ['is_ut', iconUt, 'Fossil-fired utility']];

      return _react2.default.createElement(
        'ul',
        { styleName: 'detail-holdings' },
        (0, _lodash.chain)(holdings).take(takeCount).map(function (h, idx) {
          // useful formats
          var fPerc = _format2.default.perc(fHoldingsMap[h.id].long_weight);
          var fMoney = _format2.default.money(fHoldingsMap[h.id].market_value, true, shareClass.currency, true);

          //
          return _react2.default.createElement(
            'li',
            { key: idx, styleName: 'holding' },
            _react2.default.createElement(
              'div',
              { styleName: 'holding-name' },
              _react2.default.createElement(
                'div',
                null,
                idx + 1,
                '. ',
                h.security_name
              ),
              _react2.default.createElement(
                'div',
                null,
                /* mini-sector icons */
                iconConfigs.map(function (sector) {
                  return h[sector[0]] ? _react2.default.createElement(
                    'span',
                    {
                      key: sector[0],
                      title: sector[2]
                    },
                    _react2.default.createElement('img', {
                      styleName: 'detail-icon-holding',
                      src: sector[1],
                      alt: sector[2]
                    })
                  ) : null;
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'holding-invested' },
              fMoney
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'holding-asset' },
              fPerc
            )
          );
        }).value()
      );
    }
  }]);
  return HoldingsList;
}(_react.Component), _class8.propTypes = {
  shareClass: _react.PropTypes.object,
  fHoldingsMap: _react.PropTypes.object,
  holdings: _react.PropTypes.array,
  page: _react.PropTypes.number
}, _temp4)) || _class7);
var GradeBox = (_dec5 = (0, _reactCssModules2.default)(_FundFossilFuelInvestments2.default, { allowMultiple: true }), _dec5(_class9 = (_temp5 = _class10 = function (_Component5) {
  (0, _inherits3.default)(GradeBox, _Component5);

  function GradeBox(props) {
    (0, _classCallCheck3.default)(this, GradeBox);
    return (0, _possibleConstructorReturn3.default)(this, (GradeBox.__proto__ || (0, _getPrototypeOf2.default)(GradeBox)).call(this, props));
  }

  (0, _createClass3.default)(GradeBox, [{
    key: 'render',
    value: function render() {
      // gradebar image
      var GR = _format2.default.score(this.props.shareclass.grade_fossil);
      var gr = GR.toLowerCase();
      // const gradeBar = require(`../../../static/images/bar-fff-${gr}.jpg`)

      var tip = _format2.default.fossilFuelInvestmentsGradeDescription(_convert2.default.float(this.props.shareclass.c2f5coogutweight), GR, this.props.shareclass.fund_legal_name, this.props.shareclass.ticker, this.props.shareclass.fund_id, this.props.shareclass.investment_vehicle_id);

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'grade-snapshot-' + gr },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'grade-intro' },
            _react2.default.createElement(
              'div',
              { styleName: 'grade-intro-tip' },
              tip
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _components.Link,
              {
                strong: true,
                to: _config2.default.routes.howitworks,
                title: 'How it works'
              },
              _react2.default.createElement(
                'b',
                null,
                'Methodology',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'grade-wrapper' },
          _react2.default.createElement(_components.Grade, {
            grade: this.props.shareclass.grade_fossil,
            large: true
          })
        )
      );
    }
  }]);
  return GradeBox;
}(_react.Component), _class10.propTypes = {
  shareclass: _react.PropTypes.object.isRequired
  // gradeFossil: PropTypes.number,
  // ffWeight: PropTypes.string,
}, _temp5)) || _class9);
var FundFossilFuelInvestments = (_dec6 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec7 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate blocked until page loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec8 = (0, _reactCssModules2.default)(_FundFossilFuelInvestments2.default, { allowMultiple: true }), _dec6(_class11 = _dec7(_class11 = _dec8(_class11 = (_temp6 = _class12 = function (_Component6) {
  (0, _inherits3.default)(FundFossilFuelInvestments, _Component6);

  function FundFossilFuelInvestments(props) {
    (0, _classCallCheck3.default)(this, FundFossilFuelInvestments);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (FundFossilFuelInvestments.__proto__ || (0, _getPrototypeOf2.default)(FundFossilFuelInvestments)).call(this, props));

    _this6.getChartData = function (fund, fossilFuelHoldings, fHoldingsMap) {
      // colors
      var colors = {
        'c2': '#D2371B',
        'c2end': '#FF8872',
        'co': '#A9240B',
        'coend': '#E3624A',
        'og': '#821400',
        'ogend': '#C74A33',
        'f5': '#A95C0B',
        'f5end': '#E3984A',
        'ut': '#824300',
        'utend': '#C77F33',
        'fossil': '#333',
        'gray': '#D5D5D5',
        'green': '#149A43'
      };

      // what categories are active?
      var activeSector = _this6.state.activeSector;
      var ffAsset = _convert2.default.int(fund.c2f5coogutasset);
      var ffWeight = _format2.default.perc(fund.c2f5coogutweight);
      var chartData = [];

      if (activeSector && ffAsset > 0) {
        // companies
        var num_colors = _convert2.default.int(fund[activeSector + 'count']);
        var scaleStart = colors[activeSector];
        var scaleEnd = colors[activeSector + 'end'];
        var f = _chromaJs2.default.scale([scaleStart, scaleEnd]).mode('rgb').colors(num_colors);
        // const shuffled = format.shuffle(f)
        var currIdx = -1;
        // // map holdings to pie chart data
        chartData = fossilFuelHoldings.reduce(function (filtered, holding) {
          var nameLabel = _format2.default.longString(holding.security_name, 20);
          var moneyLabel = _format2.default.money(fHoldingsMap[holding.id].market_value, true, 'USD', true);
          currIdx = (currIdx + 1) % num_colors;
          filtered.push({
            value: fHoldingsMap[holding.id].market_value,
            label: nameLabel + ' ' + moneyLabel,
            color: f[currIdx]
          });
          return filtered;
        }, []);
      } else {
        if (ffAsset > 0) {
          chartData = [{
            value: ffAsset,
            label: 'Fossil fuel stocks: ' + ffWeight,
            color: colors.fossil
          }, {
            value: _convert2.default.int(fund.fund_net_assets) - ffAsset,
            label: 'All other holdings',
            color: colors.gray
          }];
        } else {
          chartData = [{
            value: 1,
            label: 'No Fossil Fuel Stock Holdings',
            color: colors.gray
          }];
        }
      }
      return chartData;
    };

    _this6.clickSector = function (newSector, isDirty) {
      if (isDirty) {
        var sectorIsActive = newSector === _this6.state.activeSector;
        // this.scrollTo('sector-id-'+newSector)()
        _this6.setState({
          activeSector: sectorIsActive ? '' : newSector,
          sectorPage: 1
        });
      }
    };

    _this6.handleScroll = function () {}
    // if ( !this.props.result ) { return }
    // const scrollTop = event.srcElement.body.scrollTop


    // need this solution since asyncConnect and anchor links does not play nice
    ;

    _this6.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        // console.log('scrolling to:', id)
        // console.log(ele)
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this6.increment = function (incState) {
      return function () {
        var newState = {};
        newState[incState] = _this6.state[incState] + 1;
        _this6.setState(newState);
      };
    };

    _this6.increment = _this6.increment.bind(_this6);
    _this6.clickSector = _this6.clickSector.bind(_this6);
    _this6.state = {
      fossilsPage: 1,
      sectorPage: 1,
      activeSector: '' // '',
    };
    return _this6;
  }

  (0, _createClass3.default)(FundFossilFuelInvestments, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // window.addEventListener('scroll', this.handleScroll)
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // console.log('componentWillReceiveProps')
      // console.log(nextProps)
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      // loading icons
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var _props$result = this.props.result,
          fund = _props$result.fund,
          shareClass = _props$result.shareClass;
      var holdings = fund.holdings,
          fundholdings = fund.fundholdings;

      var title = shareClass.fund_legal_name + ' | Fossil fuel investments';
      var url = _config2.default.domain + this.props.location.pathname;

      // dividing up holdings by sector groups
      // could this be cached (e.g. in state) to improve performance?
      var fHoldingsMap = mapFundHoldings(fundholdings);
      var fossilFuelHoldings = filterHoldings(fHoldingsMap, holdings, function (o) {
        return o.is_c2 || o.is_co || o.is_og || o.is_f15 || o.is_ut;
      });
      var c2Holdings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_c2;
      });
      var f5Holdings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_f15;
      });
      var coHoldings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_co;
      });
      var ogHoldings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_og;
      });
      var utHoldings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_ut;
      });

      // configs for donut charts
      // Config is:
      // [
      //   active sector in state (c2, co, etc.),
      //   amount intested (c2asset, etc.)
      //   list of holdings for that screen list,
      //   text label for humans
      // ]
      var chartConfigs = [['', 'c2f5coogutasset', fossilFuelHoldings, ''], ['c2', 'c2asset', c2Holdings, 'Carbon Underground 200'], ['co', 'coasset', coHoldings, 'Coal industry'], ['og', 'ogasset', ogHoldings, 'Oil/gas industry'], ['f5', 'f5asset', f5Holdings, 'Macroclimate 50'], ['ut', 'utasset', utHoldings, 'Fossil-fired utilities']];

      // configs for "sector switch" totals and holdings lists
      var producersSectorConfig = [['c2', 'Top 200 owners of carbon reserves', 'Carbon Underground 200', 'c2count', 'c2weight', 'c2asset', c2Holdings], ['co', 'Coal industry', 'Coal miners, coal services, owners of coal reserves', 'cocount', 'coweight', 'coasset', coHoldings], ['og', 'Oil/gas industry', 'Oil/gas producers and refiners, oil field services and equipment ' + 'companies, pipeline operators', 'ogcount', 'ogweight', 'ogasset', ogHoldings]];

      var consumersSectorConfig = [['f5', 'Top 50 coal-fired utilities', 'Macroclimate 50', 'f5count', 'f5weight', 'f5asset', f5Holdings], ['ut', 'Fossil-fired utilities', 'Utilities burning fossil fuels or distributing gas', 'utcount', 'utweight', 'utasset', utHoldings]];

      // useful converts
      var isSRI = _convert2.default.boolean(fund.socially_responsible_fund || '0');
      // const isUSSIF = fund.ussif === '1.5'
      var ffCount = _convert2.default.int(fund.c2f5coogutcount);
      var ffAsset = _convert2.default.int(fund.c2f5coogutasset);
      var ffWeight = _convert2.default.float(fund.c2f5coogutweight);
      var c2Count = _convert2.default.int(fund.c2count);
      var f5Count = _convert2.default.int(fund.f5count);

      var _ticker = shareClass.ticker || null;
      var fundName = '' + fund.fund_legal_name;
      fundName = _ticker ? fundName + ' ' + _ticker : fundName;
      var _ffAsset = _format2.default.money(ffAsset, true, 'USD', false);
      var _ffWeight = _format2.default.perc(ffWeight);
      var description = fundName + ' has ' + _ffAsset + ' invested in fossil fuels, ' + _ffWeight + ' of the fund';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'fossil-fuel-banner-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h2',
              { styleName: 'fossil-fuel-banner-hl' },
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-lg' },
                'Fossil fuel companies'
              ),
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-sm' },
                'are fueling the climate crisis.'
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FundMenu, {
          active: 'Fossil fuels',
          fundId: shareClass.fund_id,
          investmentVehicleId: shareClass.investment_vehicle_id,
          name: shareClass.fund_legal_name,
          ticker: shareClass.ticker
        }),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            'div',
            { styleName: 'snapshot-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'snapshot' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 4, styleName: 'chart-sidebar-wrap' },
                  _react2.default.createElement(GradeBox, { shareclass: shareClass }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sticky-sidebar' },
                    /* Sector donut charts */
                    chartConfigs.map(function (sector) {
                      return _this7.state.activeSector === sector[0] ? _react2.default.createElement(_components.Chart, {
                        key: sector[1],
                        currency: shareClass.currency,
                        invested: _convert2.default.int(fund[sector[1]]),
                        chartData: _this7.getChartData(fund, sector[2], fHoldingsMap),
                        chartMessage: sector[3]
                      }) : null;
                    }),
                    _react2.default.createElement(_components.FlaggedFund, {
                      count: ffCount,
                      weight: ffWeight,
                      asset: ffAsset,
                      portfolioDate: fund.date
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 8, styleName: 'main-content-wrap' },
                  /* SRI + 5-Badger special congrats */
                  fund.grade_fossil === 1 && isSRI ? _react2.default.createElement(
                    'div',
                    { styleName: 'flagged-fund-clean' },
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-leaf', nospace: true }),
                    '\xA0 A grade + sustainability mandate'
                  ) : null,
                  ffCount && (c2Count || f5Count) ? _react2.default.createElement(
                    'div',
                    { styleName: 'sector-details-headline-upper' },
                    'Investments in major fossil fuel companies'
                  ) : null,
                  ffCount && (c2Count || f5Count) ? _react2.default.createElement(_components.CompanyLogos, {
                    holdings: fossilFuelHoldings,
                    fHoldingsMap: fHoldingsMap
                  }) : null,
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-details-headline-lower' },
                    'Fossil fuel holdings'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-details-info-label-energy' },
                    'Energy sector'
                  ),
                  /* Producer sector switches + company lists */
                  producersSectorConfig.map(function (sector) {
                    return _react2.default.createElement(SectorDetailsSwitches, {
                      key: sector[0],
                      clickSector: _this7.clickSector,
                      increment: _this7.increment,
                      sector: sector,
                      fund: fund,
                      shareClass: shareClass,
                      fHoldingsMap: fHoldingsMap,
                      activeSector: _this7.state.activeSector,
                      fossilsPage: _this7.state.sectorPage
                    });
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-details-info-label-utility' },
                    'Utility sector'
                  ),
                  /* Utility sector switches + company lists */
                  consumersSectorConfig.map(function (sector) {
                    return _react2.default.createElement(SectorDetailsSwitches, {
                      key: sector[0],
                      clickSector: _this7.clickSector,
                      increment: _this7.increment,
                      sector: sector,
                      fund: fund,
                      shareClass: shareClass,
                      fHoldingsMap: fHoldingsMap,
                      activeSector: _this7.state.activeSector,
                      fossilsPage: _this7.state.sectorPage
                    });
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sector-details-info' },
                    _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' }),
                    '\xA0 When calculating a portfolio\'s screen exposure, we only consider long investments, ignoring any shorts or liabilities.'
                  ),
                  /* All fossil fuel holdings list */
                  ffCount ? _react2.default.createElement(
                    _reactSlidedown.SlideDown,
                    null,
                    _react2.default.createElement(HoldingsListDisplay, {
                      increment: this.increment,
                      shareClass: shareClass,
                      fHoldingsMap: fHoldingsMap,
                      type: 'fossils',
                      label: 'All fossil fuel companies',
                      count: fund.c2f5coogutcount,
                      holdings: fossilFuelHoldings,
                      page: this.state.fossilsPage
                    })
                  ) : null
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'tweeter-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'tweeter-cta' },
                  fund.c2f5coogutcount > 0 ? _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'Share to spread the word.'
                    ),
                    _react2.default.createElement('br', null),
                    'Business as usual is fueling climate destruction.'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'Share to spread the word.'
                  )
                ),
                _react2.default.createElement(_components.Tweeter, { type: 'fund', item: shareClass })
              )
            )
          )
        ),
        _react2.default.createElement(_components.IyvScorecard, { fund: fund, shareClass: shareClass }),
        _react2.default.createElement(_components.FundShareTakeAction, { shareClass: shareClass, url: url })
      );
    }
  }]);
  return FundFossilFuelInvestments;
}(_react.Component), _class12.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class12.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp6)) || _class11) || _class11) || _class11);
exports.default = FundFossilFuelInvestments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundFossilFuelInvestments/FundFossilFuelInvestments.js
// module id = 1404
// module chunks = 0